/**
 * user-channel.js
 * 訂閱個人 Ably 頻道（user_{id}），處理即時推送的個人資料更新。
 * 依賴 ably-global.js 已將 window.ably 掛載完畢。
 */
import { DRAW_STATUS_EVENT, drawStatusOrderId } from './lib/draw-status-event.mjs'
import { QUEUE_SUMMONED_EVENT } from './lib/queue-state.mjs'
import { noticeModel } from './lib/notice.mjs'

jQuery(function($) {
    if (!WTOY_ABLY_SETTING.userChannel) return

    let userChannel = window.ably.channels.get(WTOY_ABLY_SETTING.userChannel)

    // ── 通知 toast（抽獎未成立／集單失敗／出貨接續失敗補償）：全站共用 stack，多則垂直排隊、自動淡出 ──
    function ensureNoticeStack() {
        let $stack = $('#wtoy-draw-notice-stack')
        if ($stack.length) return $stack
        $stack = $('<div id="wtoy-draw-notice-stack" role="status" aria-live="polite"></div>')
        $('body').append($stack)
        return $stack
    }

    function showNoticeToast(notice) {
        let $stack = ensureNoticeStack()
        let $toast = $('<div class="wtoy-draw-notice" role="button" tabindex="0" title="點擊關閉"></div>')
        $('<span class="wtoy-draw-notice-title"></span>').text(notice.title).appendTo($toast)
        $('<span class="wtoy-draw-notice-message"></span>').text(notice.message).appendTo($toast)
        $stack.append($toast)

        let dismissed = false
        function dismiss() {
            if (dismissed) return
            dismissed = true
            $toast.removeClass('is-visible')
            setTimeout(function() { $toast.remove() }, 300)
        }
        $toast.on('click', dismiss)
        $toast.on('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') dismiss()
        })

        requestAnimationFrame(function() {
            $toast.addClass('is-visible')
        })

        setTimeout(dismiss, 6000)
    }

    // ── 餘額統一更新（wc_points / return_points / gacha_coupons） ──────────
    userChannel.subscribe('balance_updated', function(message) {
        let wcPoints      = parseInt(message.data.wc_points, 10)
        let returnPoints  = parseInt(message.data.return_points, 10)
        let gachaCoupons  = parseInt(message.data.gacha_coupons, 10)

        // 缺欄位不覆蓋既有數字，各自獨立判斷
        if (!isNaN(wcPoints)) {
            $('.wtoy-balance-points').text(wcPoints)
        }
        if (!isNaN(returnPoints)) {
            $('.wtoy-balance-return-points').text(returnPoints)
        }
        if (!isNaN(gachaCoupons)) {
            // 頂部點數列
            $('.wtoy-balance-gacha-coupons').text(gachaCoupons)

            // 轉蛋商品頁：背包右上角張數
            $('.wgp-coupon-num').text(gachaCoupons)

            // 轉蛋券明細頁（/my-account/gacha-coupon-log/）：餘額卡數字，保留「 張」後綴
            $('.wtoy-coupon-balance-num').text(gachaCoupons + ' 張')
        }
    })

    // ── Activity B：每日轉蛋區消費滿額送 ────────────────────────────────
    userChannel.subscribe('spending_updated', function(message) {
        let spending = parseInt(message.data.spending_total, 10)
        if (isNaN(spending)) return
        let $section = $('.wac-spending-section')
        if (!$section.length) return

        let tiers   = $section.data('tiers') || []
        let maxTier = parseInt($section.data('max-tier'), 10) || 0

        $('.wac-spending-total').text('$' + spending.toLocaleString())

        let nextTier    = tiers.find(t => spending < t) || null
        let progressMax = nextTier || maxTier
        let progressPct = (progressMax > 0 && spending > 0) ? Math.min(100, Math.round(spending / progressMax * 100)) : (spending > 0 ? 100 : 0)
        $section.find('.wac-progress-fill--accent').css('width', progressPct + '%')

        let $gap = $section.find('.wac-spending-gap')
        if (nextTier) {
            $gap.find('.wac-spending-gap-next').text('$' + nextTier.toLocaleString())
            $gap.find('.wac-spending-gap-amount').text('$' + (nextTier - spending).toLocaleString())
            $gap.show()
        } else {
            $gap.hide()
        }

        // 更新門檻列狀態（is-claimed / is-reached）
        $section.closest('.wac-card').find('.wac-tier-row[data-threshold]').each(function() {
            let threshold = parseInt($(this).data('threshold'), 10)
            if (isNaN(threshold)) return
            if (spending >= threshold && !$(this).hasClass('is-claimed')) {
                $(this).addClass('is-claimed').removeClass('is-reached')
            }
        })
    })

    // ── Activity C：每日全站消費滿額送 ─────────────────────────────────
    userChannel.subscribe('spending_global_updated', function(message) {
        let spending = parseInt(message.data.spending_total, 10)
        if (isNaN(spending)) return
        let $section = $('.wac-spending-global-section')
        if (!$section.length) return

        let tiers   = $section.data('tiers') || []
        let maxTier = parseInt($section.data('max-tier'), 10) || 0

        $section.find('.wac-spending-global-total').text('$' + spending.toLocaleString())

        let nextTier    = tiers.find(t => spending < t) || null
        let progressMax = nextTier || maxTier
        let progressPct = (progressMax > 0 && spending > 0) ? Math.min(100, Math.round(spending / progressMax * 100)) : (spending > 0 ? 100 : 0)
        $section.find('.wac-progress-fill--tertiary').css('width', progressPct + '%')

        let $gap = $section.find('.wac-spending-global-gap')
        if (nextTier) {
            $gap.find('.wac-spending-global-gap-next').text('$' + nextTier.toLocaleString())
            $gap.find('.wac-spending-global-gap-amount').text('$' + (nextTier - spending).toLocaleString())
            $gap.show()
        } else {
            $gap.hide()
        }

        $section.closest('.wac-card').find('.wac-tier-row--tertiary[data-threshold]').each(function() {
            let threshold = parseInt($(this).data('threshold'), 10)
            if (isNaN(threshold)) return
            if (spending >= threshold && !$(this).hasClass('is-claimed')) {
                $(this).addClass('is-claimed').removeClass('is-reached')
            }
        })
    })

    // ── 抽獎回流頁狀態喚醒（不帶狀態，收到就補打一次 draw/status） ──
    userChannel.subscribe('draw_status_changed', function(message) {
        let orderId = drawStatusOrderId(message.data)
        if (orderId === null) return
        document.dispatchEvent(new CustomEvent(DRAW_STATUS_EVENT, { detail: { order_id: orderId } }))
    })

    // ── 排隊叫號（只送給被叫號者本人，轉給商品頁自動回應） ────────────
    userChannel.subscribe(QUEUE_SUMMONED_EVENT, function(message) {
        document.dispatchEvent(new CustomEvent(QUEUE_SUMMONED_EVENT, { detail: message.data }))
    })

    // ── 抽獎未成立／集單失敗通知：獨立於郵件開關，人在頁面上就跳 toast ──
    userChannel.subscribe('draw_notice', function(message) {
        let notice = noticeModel(message.data)
        if (notice === null) return
        showNoticeToast(notice)
    })

    // ── 出貨接續失敗補償通知：共用既有 toast stack 與 payload 正規化 ──
    userChannel.subscribe('ship_notice', function(message) {
        let notice = noticeModel(message.data)
        if (notice === null) return
        showNoticeToast(notice)
    })

    // ── Activity A：每月儲值滿額送（streak 推進） ──────────────────────
    userChannel.subscribe('streak_updated', function(message) {
        let currentDay    = parseInt(message.data.current_day, 10)
        let couponsEarned = parseInt(message.data.coupons_earned, 10)
        if (isNaN(currentDay) || isNaN(couponsEarned)) return
        let $streakList   = $('.wac-streak-list')
        if (!$streakList.length) return

        // 更新進度文字
        $('.wac-streak-current-day').text(currentDay)
        $('.wac-streak-coupons-earned').text(couponsEarned)

        // 更新進度條
        let totalDays = $streakList.find('.wac-streak-row').length || 10
        let pct       = Math.min(100, Math.round(currentDay / totalDays * 100))
        $('.wac-progress-fill--primary').css('width', pct + '%')

        // 更新各天的狀態 class + badge 顯示
        $streakList.find('.wac-streak-row[data-day]').each(function() {
            let day = parseInt($(this).data('day'), 10)
            if (isNaN(day)) return
            if (day <= currentDay && !$(this).hasClass('is-done')) {
                $(this).removeClass('is-current is-locked is-reached').addClass('is-done')
            } else if (day === currentDay + 1 && $(this).hasClass('is-current')) {
                // 今天完成後，下一天暫時變為 is-locked（明天才能繼續）
                $(this).removeClass('is-current').addClass('is-locked')
            }
        })
    })
})
